import { AvailableCriteria, GroupType, GroupWithMembers, UserRolePermission } from '@schooly/api';

import { ModalSidebarItem } from '../../components/ui/ModalSidebar';
import { TIMETABLE_ACCESS_PERMISSIONS } from '../../hooks/useTimetablePermissions';
import { SchoolPropertyType } from '@schooly/constants';

export const hasAgeGroupOutsideScope = (
  ageGroups: { id: string }[] = [],
  scopeAgeGroupIds: string[],
) => ageGroups.some((ageGroup) => !scopeAgeGroupIds.includes(ageGroup.id));

export const isAgeGroupMismatch = (memberAgeGroupIds: string[], groupAgeGroupIds: string[]) =>
  groupAgeGroupIds.length > 0 && !memberAgeGroupIds.some((id) => groupAgeGroupIds.includes(id));

export const getLimitedToAgeGroupIds = (schoolPropertyIds: string[], ageGroupIds: string[]) =>
  schoolPropertyIds.filter((id) => ageGroupIds.includes(id));

export const isCriteriaAgeGroupMismatch = (
  criteria: AvailableCriteria,
  groupAgeGroupIds: string[],
  limitedToAgeGroupIds: string[],
) => {
  if (!groupAgeGroupIds.length) return false;
  if (!limitedToAgeGroupIds.some((id) => !groupAgeGroupIds.includes(id))) return false;

  const isGroupAgeGroupCriteria =
    criteria.school_property?.type === SchoolPropertyType.AgeGroup &&
    groupAgeGroupIds.includes(criteria.school_property.id);

  return !isGroupAgeGroupCriteria;
};

export enum ViewGroupModalTabs {
  Attendance = 'attendance',
  Members = 'members',
  Timetable = 'timetable',
  Messages = 'messages',
  Assessments = 'assessments',
  Conduct = 'conduct',
  Events = 'events',
  // SignUps = 'signups',
}

export const getTabs = (
  permissions?: UserRolePermission[],
  group?: GroupWithMembers,
): ModalSidebarItem<ViewGroupModalTabs>[] => {
  if (!group) {
    return [];
  }

  const allowedAttendance =
    permissions?.includes('attendance_viewer') && group.group_type !== GroupType.NoSubject;
  const allowedAssessments =
    group.group_type !== GroupType.NoSubject && permissions?.includes('assessment_viewer');
  const allowedMessages = permissions?.includes('message_viewer');
  const allowedConduct = permissions?.includes('conduct_viewer');
  const allowedEvents = permissions?.includes('event_viewer');

  const allowedTimetable = permissions?.some((p) => TIMETABLE_ACCESS_PERMISSIONS.includes(p));

  return [
    { id: ViewGroupModalTabs.Members, title: 'groups-Members' },
    { id: ViewGroupModalTabs.Attendance, title: 'groups-Attendance', disabled: !allowedAttendance },
    {
      id: ViewGroupModalTabs.Timetable,
      title: 'profile-Timetable',
      disabled: !allowedTimetable,
    },
    {
      id: ViewGroupModalTabs.Assessments,
      title: 'groups-Assessments',
      disabled: !allowedAssessments,
    },
    { id: ViewGroupModalTabs.Messages, title: 'groups-Messages', disabled: !allowedMessages },
    { id: ViewGroupModalTabs.Conduct, title: 'groups-Conduct', disabled: !allowedConduct },
    {
      id: ViewGroupModalTabs.Events,
      title: 'section-Events',
      disabled: !allowedEvents,
    },
  ].filter((tab) => !tab.disabled);
};
